import React from 'react';
import PropTypes from 'prop-types';
import DicomDetail from './DicomDetail';
import { DICOM_PLATINUM_DETAILS, DICOM_DETAILS } from '../../graphql';
import useGetUser from '../../hooks/useGetUser';
import userHasPermission from '../../helpers/permissions';
import { BUREAUS } from '../../constants/permissions';

const DicomComponent = (
  { isNaturalPersonRut, masterEntityId, label, disabled },
) => {
  const user = useGetUser();
  const canViewDicom = userHasPermission(user, BUREAUS.VIEW_DICOM);

  if (isNaturalPersonRut) {
    return (
      <DicomDetail
        query={DICOM_PLATINUM_DETAILS}
        queryResponse="dicomsPlatinum"
        masterEntityId={masterEntityId}
        label={label}
        disabled={disabled || !canViewDicom}
      />
    );
  }
  return (
    <DicomDetail
      query={DICOM_DETAILS}
      masterEntityId={masterEntityId}
      label={label}
      disabled={disabled || !canViewDicom}
      queryResponse="dicoms"
    />
  );
};

DicomComponent.propTypes = {
  isNaturalPersonRut: PropTypes.bool,
  label: PropTypes.string,
  masterEntityId: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

DicomComponent.defaultProps = {
  isNaturalPersonRut: false,
  disabled: false,
  label: 'Detalle',
};

export default DicomComponent;
